import { EventMetadata } from '~analytics/EventMetadata';
import { EventTypes } from '~analytics/types';

export const createQuizEventMetadata: EventMetadata = {
  name: EventTypes.CreateQuiz,
  description:
    'A new quiz was created in a teacher library via any supported creation path.',
  category: 'Quiz Editor',
  platform: 'client',
  status: 'active',
  properties: {
    creation_method: {
      type: 'enum',
      values: [
        'app',
        'excel',
        'code',
        'quiz_shop',
        'link',
        'merge',
        'copy',
        'from_workspace',
        'to_workspace',
        'create_from_ai',
        'create_from_ai_import',
      ],
      description: 'Path the teacher used to create the quiz.',
      required: true,
    },
    source_soc_number: {
      type: 'string',
      description:
        'SOC number of the source quiz when duplicating or importing.',
      required: false,
    },
    source_workspace_id: {
      type: 'string',
      description:
        'Workspace the quiz was copied from, when creation is workspace-driven.',
      required: false,
    },
    destination_workspace_id: {
      type: 'string',
      description:
        'Workspace the quiz was copied to, when creation is workspace-driven.',
      required: false,
    },
    number_of_quizzes: {
      type: 'number',
      description:
        'Count of quizzes created in this operation (>1 for bulk imports).',
      required: false,
    },
  },
};
